import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nConfig, I18nModule, provideConfig, provideDefaultConfig } from '@spartacus/core';
import { knBrCustomer360EndpointsConfig } from 'src/feature-libs/kn-br-order/occ/kn-br-customer360-endpoints.config';
import { knbrOrderToolsTranslationChunksConfig, knbrOrderToolsTranslations } from './assests/public_api';
import { KnBrOrderFormsModule } from './kn-br-order-forms/kn-br-order-forms.module';
import { KnBrOrderImportModule } from './kn-br-order-import/kn-br-order-import.module';
import { KnBrOrderToolsComponent } from './kn-br-order-tools.component';
import { KnBrQuickEntryModule } from './kn-br-quick-entry/kn-br-quick-entry.module';
import { KnBrQuickOrderModule } from './kn-br-quick-order/kn-br-quick-order.module';

@NgModule({
  declarations: [KnBrOrderToolsComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    NgbModule,
    KnBrOrderImportModule,
    KnBrQuickOrderModule,
    KnBrQuickEntryModule,
    KnBrOrderFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrOrderToolsComponent: {
          component: () => import('./kn-br-order-tools.component').then((c) => c.KnBrOrderToolsComponent),
        },
      },
    } as CmsConfig),
  ],
  providers: [provideDefaultConfig(knBrCustomer360EndpointsConfig),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: knbrOrderToolsTranslations,
      chunks: knbrOrderToolsTranslationChunksConfig,
      fallbackLang: 'en',
    },
  }),
  ],
})
export class KnBrOrderToolsModule { }
